import {isWithinLastMonths} from '@utils/date';

const CLIENT_DELETE_ELIGIBILITY_MONTHS = 3;

export const isClientDeletable = (creationDatetime) => (
    isWithinLastMonths(creationDatetime, CLIENT_DELETE_ELIGIBILITY_MONTHS)
);
